import React from "react";

import AttendanceDashboard from "components/Dashboard/Attendance";

const AttendanceDashboardPage = () => {
  return <AttendanceDashboard />;
};

export default AttendanceDashboardPage;
